import React from "react";
import { Modal, Typography, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useModal, useAntdTheme } from "../../shared/hooks";
import { OrderDetail } from "./OrderDetail";

const { Title } = Typography;

type OrderDetailModalProps = {
  restaurantId: string;
  order_id: string;
  title: string;
};

export const OrderDetailModal = (props: OrderDetailModalProps) => {
  const { t } = useTranslation();
  const modal = useModal();
  const { token } = useAntdTheme();

  return (
    <>
      <a onClick={modal.open}>{props.title}</a>
      <Modal
        title={
          <Title level={4} style={{ margin: 0 }}>
            {props.title}
          </Title>
        }
        open={modal.isOpen}
        onCancel={modal.close}
        footer={[
          <Button
            key="ok"
            type="primary"
            onClick={modal.close}
            style={{
              borderRadius: token.borderRadiusLG,
              height: token.controlHeight,
            }}
          >
            {t("ok")}
          </Button>,
        ]}
        styles={{
          body: { padding: token.paddingXL },
        }}
      >
        <OrderDetail restaurantId={props.restaurantId} order_id={props.order_id} />
      </Modal>
    </>
  );
};
